module.exports = __webpack_public_path__ + "static/media/signup-icon-01.70f4ad07.svg";